import type { TranslateDictionary } from './en.js';

export const No: TranslateDictionary = {
  'Start airplay': 'Start AirPlay',
  'Stop airplay': 'Stopp AirPlay',
  Audio: 'Lyd',
  Captions: 'Undertekster',
  'Enable captions': 'Aktiver undertekster',
  'Disable captions': 'Deaktiver undertekster',
  'Start casting': 'Start kasting',
  'Stop casting': 'Stopp kasting',
  'Casting to {device}': 'Caster til {device}',
  'Enter fullscreen mode': 'Åpne fullskjerm',
  'Exit fullscreen mode': 'Avslutt fullskjerm',
  Mute: 'Demp',
  Unmute: 'Slå på lyd',
  'Enter picture in picture mode': 'Aktiver bilde-i-bilde-modus',
  'Exit picture in picture mode': 'Avslutt bilde-i-bilde-modus',
  Play: 'Spill',
  Pause: 'Pause',
  'Playback rate': 'Avspillingshastighet',
  'Playback rate {playbackRate}': 'Avspillingshastighet {playbackRate}',
  Quality: 'Kvalitet',
  'Seek backward': 'Spol tilbake',
  'Seek forward': 'Spol frem',
  Settings: 'Innstillinger',
  Auto: 'Auto',
  'audio player': 'lydavspiller',
  'video player': 'videoavspiller',
  volume: 'Volum',
  seek: 'Søk',
  'closed captions': 'Undertekster',
  'current playback rate': 'gjeldende avspillingshastighet',
  'playback time': 'avspillingstid',
  'media loading': 'laster media',
  settings: 'Innstillinger',
  'audio tracks': 'lydspor',
  quality: 'Kvalitet',
  play: 'spill',
  pause: 'pause',
  mute: 'demp',
  unmute: 'slå på lyd',
  'chapter: {chapterName}': 'kapittel: {chapterName}',
  live: 'direkte',
  Off: 'Av',
  'start airplay': 'start AirPlay',
  'stop airplay': 'stopp AirPlay',
  'start casting': 'start kasting',
  'stop casting': 'stopp kasting',
  'enter fullscreen mode': 'åpne fullskjerm',
  'exit fullscreen mode': 'avslutt fullskjerm',
  'enter picture in picture mode': 'aktiver bilde-i-bilde-modus',
  'exit picture in picture mode': 'avslutt bilde-i-bilde-modus',
  'seek to live': 'gå til direktesending',
  'playing live': 'spiller direkte',
  'seek back {seekOffset} seconds': 'spol tilbake {seekOffset} sekunder',
  'seek forward {seekOffset} seconds': 'spol frem {seekOffset} sekunder',
  'Network Error': 'Nettverksfeil',
  'Decode Error': 'Dekodingsfeil',
  'Source Not Supported': 'Kilde støttes ikke',
  'Encryption Error': 'Krypteringsfeil',
  'A network error caused the media download to fail.':
    'En nettverksfeil forårsaket at medienedlastingen mislyktes.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'En mediefeil førte til at avspillingen ble avbrutt. Mediet kan være skadet eller nettleseren din støtter ikke dette formatet.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Det oppsto en ustøttet feil. Serveren eller nettverket mislyktes, eller nettleseren din støtter ikke dette formatet.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Mediet er kryptert og det finnes ingen nøkler for å dekryptere det.',
};
